'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');

/* Components */
var Button = require('./button');

var SmallButton = React.createClass({
  displayName: 'SmallButton',

  render: function render() {
    var props = this.props;
    var newClassName = 'small-button-component' + (props.className ? ' ' + props.className : '');

    return React.createElement(Button, _extends({}, props, { className: newClassName }));
  }
});

module.exports = SmallButton;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/ui/small-button.js
 **/